import ButtonPanelGenericUI from "../behaviour/buttonPanelGenericUI/buttonPanelGenericUI";
import GameCommonGame from "../components/commongame/gameCommonGame";

import GameBaseGame from "../components/basegame/gameBaseGame";
import GameFreeGameBaseLayer from "../components/freegame/gameFreeGameBaseLayer";
import GameFreeGameSpecialLayer from "../components/freegame/gameFreeGameSpecialLayer";
import AutoplayGenericUI from "../behaviour/autoplayGenericUI/autoplayGenericUI";
import OverlayGenericUI from "../behaviour/overlayGenericUI/overlayGenericUI";
import GameRulesContainer from "../behaviour/gameRulesContainer/gameRulesContainer";
import GameSettingsContainer from "../behaviour/gameSettingsContainer/gameSettingsContainer";
import GameGeneralComponent from "../behaviour/gameGeneralComponent/gameGeneralComponent";
import GameGuideContainer from "../behaviour/gameGuideComponent/gameGuideComponent";
import GameControlComponent from "../behaviour/gameControlComponent/gameControlComponent";
import GameAutoplayComponent from "../behaviour/gameAutoplayComponent/gameAutoplayComponent";
import BetHistoryComponent from "../behaviour/betHistoryComponent/betHistoryComponent";
import CanvasAutoplay from "../behaviour/canvasAutoplay/canvasAutoplay";
import WinCelebration from "../components/winCelebration/winCelebration";

import GamePlayerMessage from "../components/playerMessage/gamePlayerMessage";
import GameBanner from "../components/banner/gameBanner";
import Multiplier from "../components/multiplier/multiplier";
import TruncateHitArea from "../components/truncateHitArea/truncateHitArea";
import GameFlowManager from "../components/flowManager/gameFlowManager";
import WinShower from "../components/winShower/winShower";
import winPanel from "../components/winpanel/winpanel";
import SkullContainer from "../components/skullcontainer/skullcontainer";
import GiantWild from "../components/giantWild/giantwild";
import RandomWild from "../components/randomwild/randomwild";
import StreakEffectContainer from "../components/streakEffectContainer/streakeffectcontainer";
import GameGridContainer from "../components/gameGridContainer/gameGridContainer";
import winDrop from "../components/windropcomponent/windrop";
import MainSettingPanelComponent from "../behaviour/mainSettingPanelComponent/mainSettingPanelComponent";
import MainSettingPanelPortraitComponent from "../behaviour/mainSettingPanelPortraitComponent/mainSettingPanelPortraitComponent";
import MobilePaytablePortrait from "../components/mobilePaytablePortrait/mobilePaytablePortrait";
import MobilePaytable from "../components/mobilePaytable/mobilePaytable";
import GameGeneralComponentPortrait from "../behaviour/gameGeneralComponentPortrait/gameGeneralComponentPortrait";
import GameAutoplayComponentPortrait from "../behaviour/gameAutoplayComponentPortrait/gameAutoplayComponentPortrait";
import GameGuideComponentPortrait from "../behaviour/gameGuideComponentPortrait/gameGuideComponentPortrait";
import CanvasAutoplayForMobile from "../behaviour/canvasAutoplayForMobile/canvasAutoplayForMobile";
import BuyFeature from "../components/buyFeature/buyFeature";

import RetriggerPopup from "../components/retriggerPopup/retriggerPopup";
import BaseGameReconstruction from "../components/baseGameReconstruction/baseGameReconstruction";


export const DC: any = {
    RetriggerPopup,
    ButtonPanelGenericUI,
    GameCommonGame,
    GameBaseGame,
    AutoplayGenericUI,
    OverlayGenericUI,
    GameFreeGameBaseLayer,
    GameFreeGameSpecialLayer,
    WinCelebration,
    GamePlayerMessage,
    GameBanner,
    Multiplier,
    TruncateHitArea,
    CanvasAutoplay,
    GameFlowManager,
    GameSettingsContainer,
    GameGeneralComponent,
    GameAutoplayComponent,
    GameRulesContainer,
    GameGuideContainer,
    GameControlComponent,
    BetHistoryComponent,
    WinShower,
    winPanel,
    winDrop,
    MainSettingPanelComponent,
    MainSettingPanelPortraitComponent,
    CanvasAutoplayForMobile,
    MobilePaytable,
    GameGuideComponentPortrait,
    MobilePaytablePortrait,
    GameGeneralComponentPortrait,
    GameAutoplayComponentPortrait,
    GameGridContainer,
    SkullContainer,
    GiantWild,
    RandomWild,
    StreakEffectContainer,
    BuyFeature,
    BaseGameReconstruction
};